import {Directive, TemplateRef} from "@angular/core";
import {DxPageHeaderBaseDirective} from "./dx-page-header-base.directive";

/**
 * Структурная директива для переопределения шаблона области под информацию о пользователе в шапке.
 * @publicApi
 */
@Directive({selector: '[dxPageHeaderUserBar]'})
export class DxPageHeaderUserBarDirective extends DxPageHeaderBaseDirective {
  constructor(public template: TemplateRef<any>) {
    super();
  }
}
